var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime } from 'luxon';
import { getTimeOptions } from 'shared/hooks';
import { providerUnscheduledNoteSchemaInstance, } from './providerUnscheduledNoteSchema';
var getNearestTimeOption = function () {
    var pastOptions = getTimeOptions(DateTime.local().startOf('day'), 24 * (60 / 15), 15).filter(function (to) { return DateTime.now() > to.dateValue; });
    return pastOptions[pastOptions.length - 1].value;
};
export var medManagerUnscheduledNoteSchemaInstance = __assign(__assign({}, providerUnscheduledNoteSchemaInstance), { defaultValues: function () { return (__assign(__assign({}, providerUnscheduledNoteSchemaInstance.defaultValues), { interactionStartTime: getNearestTimeOption() })); }, prepareFormForSave: function (form) {
        var preparedForm = providerUnscheduledNoteSchemaInstance.prepareFormForSave(form);
        delete preparedForm.sessionInfo.end;
        return preparedForm;
    } });
